function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIkonaCfin2Biala({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 87 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,-170.392,-304.023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.80525,0,0,1.80525,-455.427,280.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(24,0,0,24,439.916,243.474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.531,-0.263L0.671,-0.219C0.649,-0.141 0.614,-0.083 0.563,-0.044C0.514,-0.007 0.45,0.012 0.374,0.012C0.278,0.012 0.2,-0.02 0.139,-0.085C0.078,-0.15 0.047,-0.239 0.047,-0.352C0.047,-0.471 0.078,-0.563 0.14,-0.629C0.201,-0.695 0.282,-0.728 0.382,-0.728C0.47,-0.728 0.541,-0.702 0.596,-0.65C0.628,-0.62 0.653,-0.576 0.669,-0.519L0.526,-0.484C0.517,-0.521 0.5,-0.551 0.473,-0.572C0.446,-0.594 0.413,-0.604 0.375,-0.604C0.322,-0.604 0.279,-0.585 0.246,-0.547C0.213,-0.509 0.196,-0.448 0.196,-0.362C0.196,-0.272 0.213,-0.207 0.245,-0.169C0.278,-0.131 0.32,-0.111 0.372,-0.111C0.41,-0.111 0.444,-0.124 0.471,-0.148C0.499,-0.172 0.519,-0.211 0.531,-0.263Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.80525,0,0,1.80525,-455.427,280.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(24,0,0,24,457.248,243.474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.074,-0L0.074,-0.716L0.564,-0.716L0.564,-0.595L0.218,-0.595L0.218,-0.425L0.517,-0.425L0.517,-0.304L0.218,-0.304L0.218,-0L0.074,-0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.80525,0,0,1.80525,-455.427,280.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(24,0,0,24,471.908,243.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.068,
    y: -0.716,
    width: 0.145,
    height: 0.716,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.80525,0,0,1.80525,-455.427,280.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(24,0,0,24,478.576,243.474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.074,-0L0.074,-0.716L0.215,-0.716L0.508,-0.238L0.508,-0.716L0.642,-0.716L0.642,-0L0.497,-0L0.208,-0.467L0.208,-0L0.074,-0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-122.989,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292,652L292,811L140,811L140,720.135M140,689.774L140,609L249,609",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-122.989,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292,652L249,652L249,609",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-122.989,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249,609L292,652",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-110.989,-68)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 740,
    r: 7,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-74.8517,-91.7058)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 740,
    r: 7,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-42.5204,-54)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 740,
    r: 7,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-11.829,-69.4455)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 740,
    r: 7,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03096,-0.0209778,-0.0209778,1.01421,-114.486,-5.76132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,668L200.137,653",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.840088,0.108357,0.108357,0.926577,-98.4385,46.5843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,668L200.137,653",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.92px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.231102,1.21366,-1.11127,-0.082274,789.545,492.884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,668L200.137,653",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.88px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-123.489,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159,789L274,789",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-122.989,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.9,-92.4569,-710.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.26px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,2.4,-65.8649,-1104.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "1.04px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.33,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,2.83333,-38.0417,-1446.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 759,
    width: 17,
    height: 30,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "0.9px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonaCfin2Biala);
export default __webpack_public_path__ + "static/media/IkonaCFIN_2_biala.323a56d6c3799048f4bf9cb8c085d761.svg";
export { ForwardRef as ReactComponent };